import { useContext } from 'react';
import FormAccessContext from 'common/contexts/FormAccessContext';

export default function useFormAccessContext() {
  return useContext(FormAccessContext);
}
